<app-form-input
	[parentForm]="parentForm"
	[disabled]="disabled"
	
	[value]="radioButtonValue"
	
	[label]="step3.getspan4"
	[type]="'radio'"
	[rule]="'required'"
	[errorMessage]="{'required' : 'ctr_1094_HorsDef'}"
	[radios]="[
		{
			label: step3.gettravaux,
			value: travauxValue
		},
		{
			label: step3.getfournitures,
			value: fournituresValue
		},
		{
			label: step3.getservices,
			value: servicesValue
		}
	]"
	[name]="radioButtonCtrlName"
>
</app-form-input>
